import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { GoogleMapsApiKeyProvider } from "./context/GoogleMapsApiKeyContext";
import { AlertProvider } from "./context/AlertContext";
import { UserProvider } from "./context/UserContext";
import { LanguageProvider } from "./hooks/useLanguage";
import { ContentProvider } from "./content/useContent";

import Navigation from "./routes/Navigation";
import "./theme/style.css";
import AppThemeProvider from "./theme/AppThemeContext";

export default function App() {
  return (
    <LanguageProvider>
      <ContentProvider>
        <AppThemeProvider>
          <CssBaseline />
          <BrowserRouter>
            <UserProvider>
              <AlertProvider>
                <GoogleMapsApiKeyProvider>
                  <Navigation />
                </GoogleMapsApiKeyProvider>
              </AlertProvider>
            </UserProvider>
          </BrowserRouter>
        </AppThemeProvider>
      </ContentProvider>
    </LanguageProvider>
  );
}
